import { render, staticRenderFns } from "./Comparison.vue?vue&type=template&id=86dcd7d8&scoped=true"
import script from "./Comparison.vue?vue&type=script&lang=js"
export * from "./Comparison.vue?vue&type=script&lang=js"
import style0 from "./Comparison.vue?vue&type=style&index=0&id=86dcd7d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86dcd7d8",
  null
  
)

export default component.exports